import React, { useEffect, useState } from "react";
import MadeByBimatter from "../components/MadeByBimatter/MadeByBimatter";
import CompareVersionsViewer from "../components/Viewer/CompareVersionsViewer";

function CompareVersionsViewerPage() {
    const [files, setFiles] = useState<string[]>();
    useEffect(() => {
        const files = sessionStorage.getItem("model_paths");
        setFiles(files ? JSON.parse(files) : []);
    }, []);
    if (!files) return <></>;
    return (
        <>
            <CompareVersionsViewer model_paths={files} />
            <MadeByBimatter></MadeByBimatter>
        </>
    );
}

export default CompareVersionsViewerPage;
